import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

type NavArrowProps = {
	isRight?: boolean;
};

type NavItemProps = {
	isActive?: boolean;
};

export const Wrapper = styled.section`
	padding: 80px 0 120px;

	${minWidth('desktop')} {
		padding: 160px 0 120px;
	}
`;

export const MobileHeading = styled.h2`
	color: ${palette('gray7')};
	font-size: 36px;
	${fontWeight(FontWeights.Regular)};
	line-height: 1.5;
	margin-bottom: 55px;
	padding: 0;
	text-align: center;

	${minWidth('desktop')} {
		display: none;
	}
`;

export const CarouselWrapper = styled.div`
	margin: 0 auto;
	max-width: calc(100% - 40px);

	${minWidth('desktop')} {
		max-width: 960px;
		width: 100%;
	}

	& .slider,
	& .slider-frame,
	& .slider-list,
	& .slider-slide {
		outline: none;
	}
`;

export const BottomNav = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
	top: 48px;
`;

export const NavArrow = styled.div<NavArrowProps>`
	cursor: pointer;
	display: none;

	${minWidth('desktop')} {
		display: block;
		left: ${props => (!props.isRight ? '-120px' : 'initial')};
		position: absolute;
		right: ${props => (props.isRight ? '-120px' : 'initial')};
	}
`;

export const NavItem = styled.div<NavItemProps>`
	${({ isActive }) => `
    background-color: ${isActive ? '#A98AF1' : '#C4C4C4'};
    border-radius: 50%;
    height: 14px;
    margin-right: 8px;
    transition: 0.2s ease-out;
    width: 14px;

    &:last-of-type {
      margin-right: 0;
    }
  `}
`;
